import * as React from "react";

const IconPromoCheck: React.FC<React.SVGAttributes<SVGSVGElement>> = (
  props
) => {
  return (
    <svg width="57" height="56" viewBox="0 0 57 56" fill="none" {...props}>
      <path
        d="M51.5 25.8057V28.0137C51.4971 33.1891 49.8562 38.2249 46.8219 42.3701C43.7877 46.5153 39.5227 49.5477 34.6631 51.0151C29.8035 52.4825 24.6096 52.3063 19.856 50.5127C15.1024 48.7192 11.0439 45.4044 8.28576 41.0627C5.52758 36.721 4.21751 31.5851 4.55094 26.4209C4.88437 21.2567 6.84344 16.3409 10.136 12.4067C13.4285 8.4725 17.878 5.73065 22.821 4.59009C27.764 3.44952 32.9356 3.97135 37.5645 6.07774"
        stroke="#DFC947"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.5 10L28.6538 34L21.5 26.8072"
        stroke="#DFC947"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="46.5" cy="46" r="8" fill="#57AA55" />
    </svg>
  );
};

export { IconPromoCheck };
